<template>
  <section
      id="faqs" class="faqs push-v--mobile--medium push-v--tablet--medium push-v--desktop--large container"
  >
    <div class="faqs__block row no-gutters">
      <div class="col-12 faqs__top-block">
        <div class="row justify-content-between no-gutters push-v--desktop--medium">
          <div class="col-12 col-lg-6 col-xl-6">
            <div class="faqs__intro-block">
              <h1 class="h3 faqs__title">FAQs</h1>
              <div class="faqs__intro" v-html="faqs[0].intro" />
            </div>
          </div>

          <div v-if="faqs[0].emailAddress.length > 0 || faqs[0].phoneNumber.length > 0" class="faqs__contact-wrapper col-12 col-md-6 col-lg-6 col-xl-5">
            <div class="faqs__contact d-flex flex-column">
              <span class="faqs__contact-title">{{ faqs[0].contactDetailsTitle }}</span>
              <span v-if="faqs[0].emailAddress.length > 0" class="d-flex align-items-center">
                <Mail class="faqs__contact-icon" /><span class="faqs__contact-label">{{ faqs[0].emailTitle }}:</span>
                <a class="faqs__contact-link" :href="`mailto:${faqs[0].emailAddress}`">{{ faqs[0].emailAddress }}</a>
              </span>
              <span v-if="faqs[0].phoneNumber.length > 0" class="d-flex align-items-center">
                <Phone class="faqs__contact-icon" /><span class="faqs__contact-label">{{ faqs[0].callUsTitle }}:</span>
                <a class="faqs__contact-link" :href="`tel:${faqs[0].phoneNumber}`">{{ faqs[0].phoneNumber }}</a>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row no-gutters" style="max-width:100%;">
        <div class="col-12">
          <div v-if="faqs.length > 1" class="faqs__filters">
            <listing-filters
                :items="faqs"
                :trigger-filter="triggerFilter"
                :active-filter="activeFilter"
            />
          </div>
          <div v-for="(tab, tabIndex) in faqs" :key="tabIndex" class="faqs__faq--tabs">
            <div v-for="(item, index) in tab.items" :key="index" class="faqs__faq" :class="{'tab-hidden': activeFilter !== tab.contentCodename }">
              <FAQ v-bind="item" />
            </div>
          </div>
        </div>
      </div>

      <div v-if="faqs[0].emailAddress.length > 0 || faqs[0].phoneNumber.length > 0" class="faqs__contact-wrapper-mobile row no-gutters">
        <div class="faqs__contact d-flex flex-column">
          <span class="faqs__contact-title">{{ faqs[0].contactDetailsTitle }}</span>
          <div class="faqs__contact-type">
            <Mail class="faqs__contact-icon" />
            <div>
              <span v-if="faqs[0].emailAddress.length > 0" class="d-flex align-items-center">
                <span class="faqs__contact-label">{{ faqs[0].emailTitle }}:</span>
              </span>
              <span><a class="faqs__contact-link" :href="`mailto:${faqs[0].emailAddress}`">{{ faqs[0].emailAddress }}</a></span>
            </div>
          </div>
          <div class="faqs__contact-type">
            <Phone class="faqs__contact-icon" />
            <div>
              <span v-if="faqs[0].phoneNumber.length > 0" class="d-flex align-items-center">
                <span class="faqs__contact-label">{{ faqs[0].callUsTitle }}:</span>
              </span>
              <span><a class="faqs__contact-link" :href="`tel:${faqs[0].phoneNumber}`">{{ faqs[0].phoneNumber }}</a></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ListingFilters from '~/components/components/ListingFilters';
import FAQ from '~/components/components/Faq'; // need to ensure case matches
import Mail from '~/assets/icons/mail_white.svg?inline';
import Phone from '~/assets/icons/phone_white.svg?inline';

export default {
  components: {
    FAQ,
    Mail,
    Phone,
    ListingFilters,
  },
  props: {
    faqs: { type: Array, required: true },
  },
  data() {
    return {
      activeFilter: '',
    };
  },
  watch: {
    activeFilter() {
      return this.activeFilter;
    },
  },
  mounted() {
    // we need to make the first option filter active onLoad
    this.makeActive(this.faqs[0]);
  },
  methods: {
    triggerFilter(codename) {
      this.faqs.forEach((item, index) => {
        if (item.contentCodename === codename) {
          this.makeActive(item);
        }
      });
    },
    makeActive(item) {
      this.faqs.forEach((item, index) => {
        item.active = 0;
      });
      item.active = 1;
      this.activeFilter = item.contentCodename;
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_faqs.scss';
</style>
